<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p><span><b>To Gail and Roy Gordon,</b></span></p>
<p><span><i>who introduced me to the Sierra wilderness and advised me as I built a successful company</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?44cd1029